import ModuleMultiSelect from './ModuleMultiSelect';

export default class TagSelect extends ModuleMultiSelect
{
	Type = 'TAG';
};

